import { AnchorInLine, CardBodyTextCntr, DisclaimerContainer, PaddedContent, PaddedUL, TableWrapper } from './style'
import { Container, Main } from './style'
import { ReactComponent as InfoIcon } from '../../assets/icons/Info.svg'
import { PRIVACY_EMAIL, tableData, tableHead } from './constants'
import { BodyRegular, BodySemibold, HealLine2, SubtitleMedium } from '../../shared/typography'
import { CustomTable } from '../../components/customTable'
import Footer from '../../components/Footer'
import Nav from '../../components/Nav'

function PrivacyPolicy(props: any) {
  return (
    <>
      <Nav />

      <Container>
        <Main>
          <HealLine2>Privacy policy</HealLine2>
          <CardBodyTextCntr>
            <SubtitleMedium>1. Acceptance of Privacy Policy</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              Welcome to Lavabee NFT, LLC (“Lavabee” “we” or “us”) and our Privacy Policy (“Privacy Policy”).
              This Privacy Policy is important and affects your legal rights, so please read carefully.
            </BodyRegular>import Footer from './../../components/Footer/index';

            <BodyRegular color={"#191414"} >
              By accessing or using{' '}
              <AnchorInLine href="https://www.lavabeenft.com/" target="_blank" rel="noopener noreferrer">
                Lavabeenft.com
              </AnchorInLine>{' '}
              and various related websites and services (collectively, the “Lavabee Services”),
              you agree to be bound by this Privacy Policy and all of the terms incorporated herein by reference.
              By using the Lavabee Services and/or submitting or collecting any personal data via the Lavabee Services,
              you accept and expressly consent and agree to our practices surrounding the collection, use,
              and sharing of your personal information in accordance with this Privacy Policy.
            </BodyRegular>
            <DisclaimerContainer>
              <InfoIcon width={20} height={20} />
              <BodyRegular color={"#191414"} >
                If you do not consent and agree with the terms of this Privacy Policy, you cannot, and we do not authorize you to, access, browse, or use the Lavabee Services.
              </BodyRegular>
            </DisclaimerContainer>
            <BodyRegular color={"#191414"} >
              Our processing of personal information, such as your name, address, e-mail address,
              or telephone number, will be undertaken consistent with the requirements of applicable privacy laws,
              including, but not limited to, the California Consumer Privacy Act (“CCPA”), the General Data Protection Regulation (“GDPR”),
              the UK General Data Protection Regulation (“UK GDPR”),
              and the Canadian Personal Information Protection and Electronic Documents Act (“PIPEDA”).
            </BodyRegular>

            <SubtitleMedium>2. Information We Collect</SubtitleMedium>
            <BodySemibold color={"#191414"} >2.1 Personal Information We Collect Directly from You</BodySemibold>
            <PaddedContent>
              <BodyRegular color={"#191414"} >
                We receive personal information as described to you at the point of collection, pursuant to your consent,
                and/or when you voluntarily provide us with personal information, including:
              </BodyRegular>
              <BodyRegular color={"#191414"} >(1) individual information (such as your e-mail address and phone number);</BodyRegular>
              <BodyRegular color={"#191414"} >(2) company information (such as your company's address); and</BodyRegular>
              <BodyRegular color={"#191414"} >
                (3) other identifying information that you voluntarily choose to provide to us, including without
                limitation unique identifiers such as passwords, and personal information in messages you send to us.
              </BodyRegular>
              <BodyRegular color={"#191414"} >
                We may also collect additional information, which may be personal information, as otherwise described to you at the point of collection or pursuant to your consent.
              </BodyRegular>

            </PaddedContent>

            <BodySemibold color={"#191414"} >2.2 Information We Automatically Collect When You Use Our Site</BodySemibold>
            <PaddedContent>
              <BodyRegular color={"#191414"} >
                In order to access and use certain areas or features of the Lavabee Services, you consent to our collection
                and use of certain information about your use of the Lavabee Services through the use of tracking technologies
                or by other passive means. Your consent to our access and use of this “passively collected” information includes,
                but is not limited to, the domain name of the website that allowed you to navigate to the Lavabee Services,
                search engines used, the internet protocol (IP) address used, the length of time spent on the Lavabee Services,
                the pages you looked at on the Lavabee Services, other webpages you visited before and after visiting the Lavabee Services,
                the type of device and/or internet browser you have, the frequency of your visits to the Lavabee Services, and other relevant statistics (collectively “Traffic Data”):
              </BodyRegular>
            </PaddedContent>
            <SubtitleMedium>3. How We Collect Information</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              We collect information (including personal information and Traffic Data) when you use and interact with the Lavabee Services,
              and in some cases from third party sources. Such means of collection include:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >When you access, use, or contact us through the Lavabee Services.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >When you voluntarily provide information through the Lavabee Services.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  If you use a location-enabled browser, we may receive information about your location and device.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Through Cookies, Web Beacons, analytics services and other tracking technologies (collectively, “Tracking Tools”).
                </BodyRegular>
              </li>
            </ul>

            <SubtitleMedium>4. Tracking Tools, Behavioral Advertising, and Opt Out Options</SubtitleMedium>
            <BodySemibold color={"#191414"}>4.1 Tracking Tools</BodySemibold>
            <BodyRegular color={"#191414"} >
              We may use tools outlined below in order to provide the Lavabee Services, advertise to, and better understand users.
            </BodyRegular>
            <PaddedUL>
              <li>
                <BodyRegular color={"#191414"} >
                  <b>Cookies:</b> are small computer files transferred to your device that contain information such
                  as user ID, user preferences, lists of pages visited and activities conducted while using the Lavabee Services.
                  We use Cookies to (i) improve and tailor the Lavabee Services, (ii) customize advertisements,
                  (iii) measure performance (iv) store authentication so re-entering credentials is not required, (v) customize user experiences, and for (vi) analytics and
                  fraud prevention. For more information on Cookies, including how to control your Cookie settings and preferences, visit {' '}
                  <AnchorInLine href="http://www.allaboutCookies.org" target="_blank" rel="noopener noreferrer">
                    http://www.allaboutCookies.org
                  </AnchorInLine>
                  . You can also manage Cookies in your web browser (for example, Edge, Explorer, Chrome, Safari). If you choose to change your settings,
                  you may find that certain functions or features
                  of the Lavabee Services will not work as intended. The follow details the types of Cookies we use and why we use them:
                </BodyRegular>
                <ol type="a">
                  <li>
                    <BodyRegular color={"#191414"} >
                      <b>Absolutely necessary Cookies.</b> These Cookies are essential to enable you to move around a website and use its features.
                      Without these Cookies, services you have asked for, like adding items to an online order, cannot be provided.
                    </BodyRegular>
                  </li>
                  <li>
                    <BodyRegular color={"#191414"} >
                      <b>Performance Cookies.</b> These Cookies collect information about how you use the Lavabee Services. Information collected includes,
                      the Internet browsers and operating systems used, the domain name of the website previously visited, the number of visits,
                      average duration of visit, and pages viewed. These Cookies do not collect information that personally identifies you and only
                      collect aggregated and anonymous information. Performance Cookies are used to improve the user-friendliness of a website and enhance your experience.
                    </BodyRegular>
                  </li>
                  <li>
                    <BodyRegular color={"#191414"} >
                      <b>Functionality Cookies.</b> These Cookies allow the Lavabee Services to remember choices you make (such as your username, language preference,
                      or the area or region you are in) and provide enhanced, more personal features. These Cookies can also be used to remember changes you
                      have made to text size, fonts, and other customizable parts of the Lavabee Services. The information these Cookies collect may be anonymized,
                      and they cannot track your browsing activity on other websites.
                    </BodyRegular>
                  </li>
                </ol>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  <b>Web Beacons:</b>  “Web Beacons” (a.k.a. clear GIFs or pixel tags) are tiny graphic image files embedded in a web page or email that may be used
                  to collect information about the use of the Lavabee Services. The information collected by Web Beacons allows us to analyze how many people are using
                  the Lavabee Services, using selected publishers' websites or opening emails, and for what purpose.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  <b>Web Service Analytics:</b> We may use third-party analytics services in connection with the Lavabee Services, including,
                  for example, to register mouse clicks, mouse movements, scrolling activity and text typed into the Lavabee Services. We use the
                  information collected from these services to help make the Lavabee Services easier to use and as otherwise set forth in Section 5
                  (How We Use Your Information). These analytics services generally do not collect personal information unless you voluntarily provide it.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  <b>Mobile Device Identifiers:</b> As with other Tracking Tools, mobile device identifiers help Lavabee NFT
                  learn more about our users' demographics and Internet behaviors in order to personalize and improve the
                  Lavabee NFT Services. Mobile device identifiers are data stored on mobile devices that may track
                  activities occurring on and through it, as well as the applications installed on it. Mobile device
                  identifiers enable collection of personal information (such as media access control, address and
                  location) and Traffic Data.
                </BodyRegular>
              </li>
            </PaddedUL>
            <SubtitleMedium>4.2 Behavioral Advertising</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              We may use a type of advertising commonly known as interest-based or online behavioral advertising. This means that some of our partners use Tracking Tools
              to collect information about a user's online activities to display Lavabee ads to the user based on the user's interests (“Behavioral Advertising”).
              Our partners may include third-party advertisers and other third party service providers, and such partners may collect information when you use
              the Lavabee Services, such as IP address, mobile device ID, operating system, and demographic information. These Tracking Tools help Lavabee learn
              more about our users' demographics and Internet behaviors.
            </BodyRegular>
            <SubtitleMedium>4.3 Options for Opting out of Cookies and Mobile Device Identifiers</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              If we process Cookies based on your consent (as indicated at the time of collection of such data), you have the right to withdraw your consent at
              any point in time by contacting us at {PRIVACY_EMAIL}. Please note, if you exercise this right, you may have to provide your consent on a case-by-case
              basis to enable you to utilize some or all of the Lavabee Services.
            </BodyRegular>
            <BodyRegular color={"#191414"} >
              You may be able to reject Cookies and/or mobile device identifiers by activating the appropriate setting on your browser or device.
              Although you are not required to accept Lavabee's Cookies or mobile device identifiers,
              if you block or reject them, you may not have access to all features available through the Lavabee Services.
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >
                  You may opt out of receiving certain Cookies by visiting the Network Advertising Initiative (NAI) opt
                  out page or the Digital Advertising Alliance (DAA) opt out page, or by installing the DAA's AppChoice
                  app (for {' '}
                  <AnchorInLine
                    href="https://play.google.com/store/apps/details?id=com.DAA.appchoices&amp;hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    iOS
                  </AnchorInLine>;
                  for{' '}
                  <AnchorInLine
                    href="https://play.google.com/store/apps/details?id=com.DAA.appchoices&amp;hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Android
                  </AnchorInLine>{' '}
                  ) on your mobile device. When you use these opt-out features, an “opt-out” Cookie will be placed on your
                  device indicating that you do not want to receive interest-based advertising from NAI or DAA member
                  companies. If you delete Cookies on your device, you may need to opt out again. For information about
                  how to opt out of interest-based advertising on mobile devices, please visit{' '}
                  <AnchorInLine
                    href="http://www.applicationprivacy.org/expressing-your-behavioral-advertising-choices-on-a-mobile-device"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    http://www.applicationprivacy.org/expressing-your-behavioral-advertising-choices-on-a-mobile-device
                  </AnchorInLine>
                  . You will need to opt out of each browser and device for which you desire to apply these opt-out
                  features.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Even after opting out of Behavioral Advertising, you may still see Lavabee advertisements that are not interest-based (i.e., not targeted toward you).
                  Also, opting out does not mean that Lavabee is no longer using Tracking Tools. Lavabee still may collect information about your use of the Lavabee Services
                  even after you have opted out of Behavioral Advertising and may still serve advertisements to you via the Lavabee Services based on information it collects
                  through the Lavabee Services.
                </BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              This Privacy Policy does not cover the use of Cookies and other Tracking Tools by any third parties, and we are not responsible for the privacy practices of any third party.
              Please be aware that some third party Cookies can continue to track your activities online even after you have left the Lavabee Services.
            </BodyRegular>
            <SubtitleMedium>4.4 How Lavabee Responds to Browser “Do Not Track” (DNT) Signals</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              Some web browsers (including Safari, Internet Explorer, Firefox and Chrome) incorporate a “Do Not Track” (DNT) or similar feature that signals to
              web services that a visitor does not want to have their online activity and behavior tracked. If a web service operator elects
              to respond to a particular DNT signal, the web service operator may refrain from collecting certain personal information about the browsers user.
              Not all browsers offer a DNT option and there is currently no industry consensus as to what constitutes a DNT signal. For these reasons,
              many web service operators, including Lavabee, do not proactively respond to DNT signals. For more information about DNT signals, visit{' '}
              <AnchorInLine href="http://allaboutdnt.com" target="_blank" rel="noopener noreferrer">
                http://allaboutdnt.com
              </AnchorInLine>
              .
            </BodyRegular>
            <SubtitleMedium>5. How We Use Your Information</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              We do not engage in automated decision making. We may use information (including information that has been de-identified and/or aggregated)
              to better understand who uses the Lavabee Services and how we can deliver a better user experience. We use information,
              including personal information, to provide the Lavabee Services and to help improve the Lavabee Services, to develop new services,
              and to advertise our services. Specifically, such use may include:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >Providing you with the products, services and information you request.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >Corresponding with you.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Providing, maintaining, administering or expanding the Lavabee Services, performing business analyses, and for other internal purposes.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Combining information received from third parties with information that we have from or about you and
                  using the combined information for any of the purposes described in this Privacy Policy.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Showing you advertisements, including interest-based or online behavioral advertising.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Fulfilling our legal obligations, such as preventing, detecting and investigating security incidents,
                  fraud, and potentially illegal or prohibited activities.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >Enforcing our Privacy Policy and other agreements.</BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              By providing your e-mail and/or phone number and checking a box, clicking the “complete” button, or some other affirmative act,
              you are consenting to receive e-mails and/or calls and text messages, including live, prerecorded, and/or automated calls and messages,
              to that email or phone number. After signing up, you will receive a confirmation e-mail or text message from Lavabee on your mobile number.
              This agreement is not entered into as a term or requirement of any purchase or promotion. Normal message and data rates may apply. Message
              frequency may vary. Neither we nor the participating carriers guarantee that messages will be delivered. We may discontinue these programs at any time without notice.
            </BodyRegular>
            <SubtitleMedium>6. How We Share Your Information</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              In certain circumstances, and in order to perform the Lavabee Services, we may share certain information about you as described in this section:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >We do not sell your personal information to third parties.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We may share your personal information with our partners to customize or display our advertising.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We may share your personal information and/or Traffic Data with our partners who perform operational
                  services for us (such as hosting, billing, fulfillment, data storage, security, insurance verification,
                  web service analytics, or ad serving).
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We may share your personal information and/or Traffic Data with our partners to analyze device
                  activities and generate targeted advertisements.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We may transfer your personal information to another company in connection with a proposed merger, sale,
                  acquisition or other change of ownership or control by or of Lavabee (whether in whole or in part).
                  We will make reasonable efforts to notify you before your information becomes subject to different privacy practices.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We also may need to disclose your personal information or any other information we collect about you if we determine in good
                  faith that such disclosure is needed to: (1) comply with or fulfill our obligations under applicable law; (2) protect the rights,
                  property or safety of you, Lavabee or another party; (3) enforce this Privacy Policy or other agreements with you; or (4) respond
                  to claims that any posting or other content violates third-party rights.
                </BodyRegular>
              </li>
            </ul>
            <SubtitleMedium>7. Storage and Security of Information</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              Any information you send to us electronically, while using the Lavabee NFT Services or otherwise interacting
              with us, may not be secure when it is transmitted to us. We recommend that you do not use unsecure channels
              to communicate sensitive or confidential information to us. Please be aware, despite our best efforts, no
              security measures are perfect or impenetrable, and we cannot guarantee “perfect security.” Any information
              you send us through any means is transmitted at your own risk.
            </BodyRegular>
            <SubtitleMedium>8. Your Choices</SubtitleMedium>
            <BodySemibold color={"#191414"} >8.1 Information You Provide</BodySemibold>
            <PaddedContent>
              <BodyRegular color={"#191414"} >
                You can choose whether or not to provide personal information through the Lavabee Services.
                We will not discriminate against you for exercising any of your rights relating to your personal
                information and will not (i) deny you goods or services, (ii) provide you with a different level or quality of services,
                or (iii) charge you different prices for services for doing so.
              </BodyRegular>
            </PaddedContent>
            <BodySemibold color={"#191414"} >8.2 California Privacy Rights</BodySemibold>
            <BodyRegular color={"#191414"} >
              In the preceding 12 months, we collected and disclosed for a business purpose the following categories of
              personal information about California consumers:
            </BodyRegular>
          </CardBodyTextCntr>

          <TableWrapper borderless>
            <CustomTable data={tableData} columns={tableHead} />
          </TableWrapper>

          {/* <TableData /> */}
          <CardBodyTextCntr>
            <BodyRegular color={"#191414"} >
              <b>Purposes for Collection, Use, and Sharing.</b> We use and disclose the personal information we collect
              for our commercial purposes, as further described in this Privacy Policy, including for our business
              purposes with our partners and service providers as follows:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >Legal compliance and auditing related to our interactions with you.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  Detecting security incidents, protecting against malicious, deceptive, fraudulent, or illegal activity,
                  and exercising our related rights.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >Performing and improving out services (by us or our service provider(s)).</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >Internal operations.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >Other one-time or short-term uses.</BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              <b>Your Rights</b>. If you are a California resident you may have the following rights under the CCPA in
              relation to personal information we have collected about you, to the extent required by the CCPA and subject
              to verification:
            </BodyRegular>
            <BodyRegular color={"#191414"} >
              <b>Right to Know/Access:</b> The right to request certain information about our collection and use of personal
              information about you as described below:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >The specific pieces of your personal information collected.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >The categories of your personal information collected.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >The categories of sources from whom your personal information is collected.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >The purpose for collecting your personal information.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >The categories of third parties with whom we have shared your personal information.</BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              <b>Right to Delete:</b> The right to request that we delete certain personal information we have about you.
            </BodyRegular>
            <BodyRegular color={"#191414"} >
              <b>Freedom from Discrimination:</b> You have the right to be free from unlawful discrimination for exercising any
              of the rights above.
            </BodyRegular>
            <BodyRegular color={"#191414"} >
              To make a request in relation to the above rights, please contact us using the information in Section 13
              below. To fulfil your request, we will need to verify your identity. Only you or someone legally authorized
              to act on your behalf may make a request related to your personal information. To designate an authorized
              agent, the authorized agent must provide sufficient information that allows us to reasonably verify that you
              authorize them to act on your behalf.
            </BodyRegular>
            <SubtitleMedium>8.3 Canada, European Union and United Kingdom Privacy Rights</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              If our processing of your personal information is subject to GDPR, UKGDPR, and/or PIPEDA, and unless subject
              to an exemption, you may have the following rights with respect to your personal information:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >
                  To request a copy of the personal information we hold about you and where possible, to transmit that
                  data directly to another data controller.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >To request we correct any personal information about you.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  To request your personal information be erased when no longer necessary for us to retain such data;
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >To withdraw your consent to the processing of your personal information.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >To request a copy of the personal information we hold about you.</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We have a legitimate interest in processing your personal information. For example, we may process your personal information to
                  send you marketing communications, to communicate with you about the Lavabee Services, and to provide and improve the Lavabee Services.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >To object to the processing of personal information (where applicable).</BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >To lodge a complaint with a data supervisory authority.</BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              We will need to verify your identity to process any requests described in this Section and may deny your
              request if we are unable to verify your identity. Government or other identification may be required.
            </BodyRegular>
            <BodyRegular color={"#191414"} >
              If you are a resident of the European Economic Area (“EEA”), when we process your personal information, we
              will only do so in the following situations:
            </BodyRegular>
            <ul>
              <li>
                <BodyRegular color={"#191414"} >
                  We need to use your information to perform our responsibilities under our agreement with you.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >
                  We have a legitimate interest in processing your personal information. For example, we may process your
                  personal information to send you marketing communications, to communicate with you about the Lavabee NFT
                  Services, and to provide and improve the Lavabee NFT Services.
                </BodyRegular>
              </li>
              <li>
                <BodyRegular color={"#191414"} >We have your consent to do so.</BodyRegular>
              </li>
            </ul>
            <BodyRegular color={"#191414"} >
              If your personal data is subject to GDPR or UK GDPR, we will transfer personal data from the EEA to a
              location outside the EEA only when there has been a documented adequacy determination, or where we have
              confirmed adequate privacy protections. If your personal data is subject to PIPEDA, we will transfer
              personal data from Canada to locations outside Canada only where we have confirmed adequate privacy
              protections. If we transfer personal data to a third party acting as our agent, we will also obligate the
              third party to have adequate privacy protections in place.
            </BodyRegular>
            <SubtitleMedium>9. How Long We Retain Your Information</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              We retain personal information about you for as long as necessary to provide you the Lavabee Services.
              In some cases, we retain personal information for longer, if doing so is necessary to comply with our
              legal obligations, or as otherwise permitted by applicable law. Afterwards, we retain some information
              in a de-identified and/or aggregated form but not in a way that would identify you personally.
            </BodyRegular>

            <SubtitleMedium>10. Information Provided on Behalf of Children and Others</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              The Lavabee Services are not intended for use by children. Individuals under the age of 18 may not use the
              Lavabee Services. Lavabee does not knowingly collect any information from children. If you are under 18,
              do not attempt to register for the Lavabee Services or send us any personal information. By accessing,
              using and/or submitting information through the Lavabee Services, you represent that you are not younger
              than 18 and that you have authority to do so. If you are a parent or legal guardian of a minor child,
              you may, in compliance with this Privacy Policy, use the Lavabee Services on behalf of such minor child.
              Information you provide through the Lavabee Services on behalf of a minor child will be treated as personal
              information as provided herein. If you use the Lavabee Services on behalf of another person, regardless of
              age, you represent and warrant that you have authority to do so.
            </BodyRegular>

            <SubtitleMedium>11. Third Party Web Services</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              The Lavabee Services may contain links or content from third party websites. A link or content from a third
              party website does not mean we endorse that website, the accuracy of information presented, or the persons
              or entities associated with that website. If you visit a third party website, you are subject to the privacy
              policy of the applicable third party and we are not responsible for the policies and/or practices of any
              third party. We encourage you to ask questions before you disclose your information to others.
            </BodyRegular>

            <SubtitleMedium>12. Updates and Changes to Privacy Policy</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              The effective date of this Privacy Policy is set forth at the top of this webpage. We will notify you of any
              material change by posting notice on this webpage. Your continued use of the Lavabee Services after the
              effective date of any amendment to this Privacy Policy constitutes your acceptance of the amended Privacy Policy.
              We encourage you to periodically review this page for the latest information on our privacy practices.
              Any amended Privacy Policy supersedes all previous versions.
            </BodyRegular>
            <DisclaimerContainer align='center'>
              <InfoIcon width={20} height={20} />
              <BodyRegular color={"#191414"} >
                If you do not agree to future changes to this privacy policy, you must stop using the Lavabee services after the effective date of such changes.
              </BodyRegular>
            </DisclaimerContainer>
            <SubtitleMedium>13. Contact Us</SubtitleMedium>
            <BodyRegular color={"#191414"} >
              The data controller for the purposes of GDPR, UK GDPR, PIPEDA or other data protection laws is Lavabee.
              If you have any questions about this Privacy Policy, please contact us at {PRIVACY_EMAIL} or at:
            </BodyRegular>
            <BodyRegular color={"#191414"} >Lavabee NFT, LLC</BodyRegular>
            <BodyRegular color={"#191414"} ></BodyRegular>
            <BodyRegular color={"#191414"} >Attn:</BodyRegular>
            <BodyRegular color={"#191414"} ></BodyRegular>
            <BodyRegular color={"#191414"} ></BodyRegular>
            <BodyRegular color={"#191414"} ></BodyRegular>

          </CardBodyTextCntr>
        </Main>
        <Footer />
      </Container>
    </>
  )
}


export default PrivacyPolicy;
